export default __webpack_public_path__ + "static/media/Ballroll_00282.9a135b7b.png";